import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const WEBSITE_CONFIGURATION_ENDPOINTS = {
  V1: createEndpoints('v1', {
    WEBSITE_SERVICES_CONFIGURATION_OPTIONS: '/admin/website-services-configuration-hub/options',
    WEBSITE_SERVICES_CONFIGURATION: (serviceId: string) => `/admin/website-services-configuration-hub/${serviceId}`,
    GALLERY_IMAGES: (serviceId: string) => `/admin/dynamic-services/${serviceId}/gallery-images/`,
    GALLERY_IMAGE_DETAIL: (serviceId: string, imageId: number) => `/admin/dynamic-services/${serviceId}/gallery-images/${imageId}/`,
    REORDER_GALLERY: (serviceId: string) => `/admin/dynamic-services/${serviceId}/gallery-images/reorder/`,
    SEO_DATA: (serviceId: string) => `/admin/dynamic-services/${serviceId}/seo/`,
  }),
} as const;
